import { render, staticRenderFns } from "./85.vue?vue&type=template&id=e28668c2&scoped=true&"
var script = {}
import style0 from "./85.vue?vue&type=style&index=0&id=e28668c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28668c2",
  null
  
)

export default component.exports